import { aiWidgetAliases } from 'components/AiAnalytics/shared/aiWidgetActions';
import { hasRenderableWidgetData } from 'components/AiAnalytics/shared/aiWidgetGuards';
import { DispositionChangeDistributionApiResponse } from 'components/AiAnalytics/shared/aiWidgetResponse.types';
import { DispositionChangeView } from './DispositionChange.types';

const buckets = [
  {
    name: 'improved',
    label: 'Improved',
    id: 'improved',
    color: '#168f86',
    reasonsHeading: 'Top improvement reasons',
  },
  {
    name: 'unchanged',
    label: 'Stable',
    id: 'unchanged',
    color: '#f5a623',
    reasonsHeading: 'Top stability reasons',
  },
  {
    name: 'degraded',
    label: 'Worsened',
    id: 'degraded',
    color: '#d64545',
    reasonsHeading: 'Top worsening reasons',
  },
] as const;

export const mapDispositionChangeResponse = (response: unknown): DispositionChangeView | null => {
  if (!hasRenderableWidgetData(aiWidgetAliases.DISPOSITION_CHANGE, response)) return null;
  const { data } = response as DispositionChangeDistributionApiResponse;
  const values = new Map(data.series.map((point) => [point.name, point.value] as const));
  if (values.size !== buckets.length || buckets.some(({ name }) => !values.has(name))) return null;
  const segments = buckets.map(({ name, label, id, color }) => ({
    id,
    label,
    color,
    value: values.get(name) as number,
  }));
  const dominantInfo = buckets.find((bucket) => bucket.name === data.dominant_bucket);
  if (!dominantInfo) return null;
  const dominant = segments.find((segment) => segment.id === dominantInfo.id);
  if (!dominant) return null;
  const reasonGroup = data.reasons.find((group) => group.bucket === data.dominant_bucket);
  if (!reasonGroup) return null;
  return {
    segments,
    dominant,
    dominantPct: data.dominant_pct,
    reasons: reasonGroup.items,
    reasonsHeading: dominantInfo.reasonsHeading,
    hasActivity: segments.some((segment) => segment.value > 0),
  };
};
